const react_config = {
    deploy: false, // For some cross origin stuff
    auto_login: true,
    host: "localhost",
    port: 23001,
    logging: true,
    protocol: "http",
    debug: true, // Some GUI enhancements for dev
};

const local_config = {
    deploy: true,
    auto_login: false,
    host: "127.0.0.1",
    port: 23001,
    logging: true,
    protocol: "http",
    debug: true,
};

const anizmow_config = {
    deploy: true,
    auto_login: false,
    host: "85.214.96.184",
    port: 23001,
    logging: true,
    protocol: "http",
    debug: true,
};

const net_config = {
    deploy: false,
    auto_login: false,
    host: "sn.hello-world.games",
    port: 80,
    logging: true,
    protocol: "https",
    debug: true,
};

const mesaverse_config = {
    deploy: true,
    auto_login: false,
    host: "sn.mesaverse.dev",
    port: 443,
    logging: true,
    protocol: "https",
    debug: false,
};

const configs = {
    react: react_config,
    local: local_config,
    anizmow: anizmow_config,
    net: net_config,
    mesaverse: mesaverse_config,
}

console.log("Using config: '" + process.env.REACT_APP_CONFIG + "'");
const config = configs[process.env.REACT_APP_CONFIG];
if (!config) {
    throw new Error("No config configured. REACT_APP_CONFIG needs to be set");
}

export default config;
